import { useTableActionContext } from '@aibees/elephant/context';
import { useMemo } from 'react';
import { filterLabelsByVisibility } from '../../../utils/filter-labels-by-visibility';

interface UseDisabledRemoveParams {
  isLabel: boolean;
}

export function useDisabledRemove({
  isLabel,
}: UseDisabledRemoveParams): boolean {
  const {
    labels: globalLabels,
    lists: globalLists,
    tabValue,
  } = useTableActionContext();

  return useMemo(() => {
    const array = isLabel ? globalLabels : globalLists;
    const filteredArray = filterLabelsByVisibility(array, tabValue);

    return filteredArray.length === 0;
  }, [globalLabels, globalLists, isLabel, tabValue]);
}
